import React from 'react'

import { useProject } from './_load/ProjectLoader'
import { useSaveProject } from './_requests/saveProject'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditProjectForm = () => {
  const [onSubmit, { loading, error }] = useSaveProject()
  const data = useProject() || {}

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={data}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditProjectForm
